import React from "react";
import useReveal from "../../hooks/useReveal";
import useSEO from "../../seo/useSEO";
import { aboutPageSchema, breadcrumb } from "../../seo/schemas";
import portrait from "../../Assets/oguzhan-ozcelik.jpeg";
import Stack from "../Home/Stack";
import { HiOutlineMusicalNote } from "react-icons/hi2";
import { GiBasketballBall, GiMountainRoad } from "react-icons/gi";

export default function About() {
  useReveal();
  useSEO({
    title: "About — Oguzhan Ozcelik | Full-Stack Developer & Shopify Expert",
    description:
      "Background, skills and tools of Oguzhan Ozcelik (Ozzy) — full-stack developer & Shopify expert based in New York, US.",
    path: "/about",
    type: "profile",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        aboutPageSchema(),
        breadcrumb([
          { name: "Home", path: "/" },
          { name: "About", path: "/about" },
        ]),
      ],
    },
    jsonLdId: "about-jsonld",
  });

  return (
    <main>
      <section className="about-hero section--hero">
        <div className="container-x reveal">
          <span className="eyebrow">About</span>
          <h1 className="about-hero__title">
            Engineer, builder,
            <br />
            <span className="it text-accent">curious human.</span>
          </h1>
        </div>
      </section>

      <section className="section section--tight">
        <div className="container-x">
          <div className="about-bio">
            <div className="about-bio__text reveal">
              <p>
                Hi, I'm <span className="accent">Oguzhan Ozcelik</span> — most
                people call me <span className="accent">Ozzy</span>. I'm a
                full-stack developer based in New York, US, with a deep focus
                on Shopify, React and Node.js.
              </p>
              <p>
                I love building products that feel <em>fast</em> and{" "}
                <em>thoughtful</em> — from Liquid themes that don't fight you,
                to APIs that don't break under load, to UIs that respect the
                user's time. I work with founders, agencies and product teams
                to ship things that actually move the metric.
              </p>
              <p>
                Outside of code, I play guitar (badly, happily), shoot hoops,
                ride bikes and read more than I should.
              </p>

              <ul className="activity-list">
                <li><HiOutlineMusicalNote /> Guitar</li>
                <li><GiBasketballBall /> Basketball</li>
                <li><GiMountainRoad /> Cycling</li>
              </ul>

              <div className="quote-card">
                <p>
                  "Working doesn't mean getting tired and sweating. It is
                  imperative to make maximum use of science, technique and
                  all kinds of civilized inventions according to the
                  requirements of the time."
                </p>
                <cite>— Mustafa Kemal Atatürk</cite>
              </div>
            </div>

            <aside className="about-bio__photo reveal">
              <img src={portrait} alt="Oguzhan Ozcelik" loading="lazy" />
            </aside>
          </div>
        </div>
      </section>

      <Stack />
    </main>
  );
}
